'use client';

import { useEffect, useRef } from 'react';

interface ClickAwayListenerProps {
  children: React.ReactNode;
  onClickAway: (event: MouseEvent) => void;
}

const ClickAwayListener = ({
  children,
  onClickAway,
}: ClickAwayListenerProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Check if the click is inside any portal content
      const portalContent = document.querySelector('[data-portal-content]');
      const target = event.target as Node;

      if (portalContent && portalContent.contains(target)) {
        return;
      }

      // Only handle clicks that are outside the wrapper
      if (wrapperRef.current && !wrapperRef.current.contains(target)) {
        onClickAway(event);
      }
    };

    // Add event listener for clicks
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // Clean up event listener on component unmount
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClickAway]);

  return (
    <div
      ref={wrapperRef}
      onClick={(e) => {
        // Stop propagation to prevent the click from reaching the document
        e.stopPropagation();
      }}
    >
      {children}
    </div>
  );
};

export default ClickAwayListener;
